// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressPieChart_container__3HkRi","chartContainer":"ProgressPieChart_chartContainer__18WPd","percentInCenter":"ProgressPieChart_percentInCenter__1doO3"};